import { Component, ElementRef, HostListener, Renderer2, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from "../../shared/pipes/translate.pipe";
import { LanguageService } from "../../shared/services/language.service";
import { HeadlineComponent } from "../../shared/elements/headline/headline.component";
import { IconBadgeComponent } from "../../shared/elements/icon-badge/icon-badge.component";
import { FormInputComponent } from "../../shared/elements/form-input/form-input.component";
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormButtonComponent } from "../../shared/elements/form-button/form-button.component";
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { FormDropdownComponent } from "../../shared/elements/form-dropdown/form-dropdown.component";
import { ToastModule } from '@syncfusion/ej2-angular-notifications';
import { LinkComponent } from "../../shared/elements/link/link.component";
import { ApiService } from "../../shared/services/api.service";
import { TYPE } from "../../shared/types/types";
import { LayoutService } from "../../shared/services/layout.service";
import { AvatarComponent } from "../../shared/elements/avatar/avatar.component";
import { TooltipModule } from "@syncfusion/ej2-angular-popups";
import { TooltipComponent } from "../../shared/elements/tooltip/tooltip.component";
import { DialogService } from "../../shared/services/dialog.service";
import { StepHeaderComponent } from "../../shared/elements/step-header/step-header.component";
import { StepContentComponent } from "../../shared/elements/step-content/step-content.component";
import { FormLabelComponent } from "../../shared/elements/form-label/form-label.component";
import { FormTextareaComponent } from "../../shared/elements/form-textarea/form-textarea.component";
import { FormUserGroupMailComponent } from "../../shared/elements/form-user-group-mail/form-user-group-mail.component";
import { FormCheckboxComponent } from "../../shared/elements/form-checkbox/form-checkbox.component";
import { FormDateTimeComponent } from "../../shared/elements/form-date-time/form-date-time.component";
import { FormDateComponent } from "../../shared/elements/form-date/form-date.component";
import { ToasterService } from "../../shared/services/toaster.service";
import { FormNumericComponent } from "../../shared/elements/form-numeric/form-numeric.component";
import { FormRadioComponent } from "../../shared/elements/form-radio/form-radio.component";
import { ContentComponent } from "../../shared/elements/content/content.component";
import { SliderModule, RatingModule } from '@syncfusion/ej2-angular-inputs';
import { TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { DialogDocumentsUploadComponent } from "../../modules/documents/dialog-documents-upload/dialog-documents-upload.component";
import { RouterService } from "../../shared/services/router.service";
import { PillComponent } from "../../shared/elements/pill/pill.component";
import { FormTimeComponent } from "../../shared/elements/form-time/form-time.component";
import { ProgressBarModule, ProgressAnnotationService } from '@syncfusion/ej2-angular-progressbar';
import { ITextRenderEventArgs } from '@syncfusion/ej2-progressbar';
import { AccordionModule } from "@syncfusion/ej2-angular-navigations";
import { AccumulationChartModule } from '@syncfusion/ej2-angular-charts'
import { PieSeriesService, AccumulationLegendService, AccumulationTooltipService, AccumulationAnnotationService, AccumulationDataLabelService, ChartModule } from '@syncfusion/ej2-angular-charts'
import { GridModule, PageService, SortService, FilterService } from '@syncfusion/ej2-angular-grids';
import { CheckBoxSelectionService } from '@syncfusion/ej2-angular-dropdowns';
import { ColumnSeriesService, CategoryService, ZoomService, LegendService, DataLabelService } from '@syncfusion/ej2-angular-charts';
import { FileStorageResource } from '../../shared/types/generated/fileStorageResource';
import {NgSrcImageErrorDirective} from '../../shared/directives/ng-src-image-error.directive';

declare let bootstrap: any;
@Component({
  selector: 'app-workflowssd',
  imports: [
    CommonModule,
    DialogModule,
    TranslatePipe,
    HeadlineComponent,
    FormInputComponent,
    FormButtonComponent,
    FormDropdownComponent,
    ToastModule,
    IconBadgeComponent,
    LinkComponent,
    AvatarComponent,
    TooltipModule,
    TooltipComponent,
    StepHeaderComponent,
    StepContentComponent,
    FormLabelComponent,
    FormTextareaComponent,
    FormUserGroupMailComponent,
    FormCheckboxComponent,
    FormDateTimeComponent,
    FormNumericComponent,
    FormRadioComponent,
    ContentComponent,
    SliderModule,
    RatingModule,
    FormDateComponent,
    TimePickerModule,
    DialogDocumentsUploadComponent,
    PillComponent,
    FormTimeComponent,
    ProgressBarModule,
    AccordionModule,
    AccumulationChartModule,
    GridModule,
    ChartModule,
      NgSrcImageErrorDirective
  ],
  templateUrl: './workflowssd.component.html',
  styleUrl: './workflowssd.component.scss',
  providers: [CheckBoxSelectionService,
    ProgressAnnotationService,
    PieSeriesService,
    AccumulationLegendService,
    AccumulationTooltipService,
    AccumulationDataLabelService,
    AccumulationAnnotationService, PageService,
    SortService,
    FilterService,
    ColumnSeriesService,
    CategoryService,
    LegendService,
    DataLabelService,
    ZoomService,
    LegendService
  ]
})
export class WorkflowsSDComponent {
  layoutService = inject(LayoutService);
  private formBuilder = inject(FormBuilder);
  private languageService = inject(LanguageService);
  private apiService = inject(ApiService);
  dialogService = inject(DialogService);
  private toasterService = inject(ToasterService);
  private elRef = inject(ElementRef);
  private renderer = inject(Renderer2);
  routerService = inject(RouterService);

  @ViewChild('showWorkflowOverview') showWorkflowOverview: DialogComponent | any;
  @ViewChild('showWorkflowOverviewForTile') showWorkflowOverviewForTile: DialogComponent | any;
  @ViewChild('showAllStageParticipants') showAllStageParticipants: DialogComponent | any;
  @ViewChild('createNewWorkflowDialog') createNewWorkflowDialog: DialogComponent | any;
  @ViewChild('showWorkflowStats') showWorkflowStats: DialogComponent | any;
  @ViewChild('showWorkflowInstanceStats') showWorkflowInstanceStats: DialogComponent | any;
  @ViewChild('showRequestersList') showRequestersList: DialogComponent | any;



  /**** FORM GROUP */
  public workflowForm: FormGroup = this.formBuilder.group({
    workflowTileFilter: ['all'],
    search_feedback_string: [''],
    search_feedback_instance_string: [''],
    workflowByUserFilter: [0],
    workflowCompletedFilter: ['recent'],
    selected_workflow: [],
    workflowSelectedFilter: ['none'],
    workflow_external_link: ['https://stage.max-toolbox.com/intranet/detail/13779153'],
    date_start: [''],
    date_end: [''],
    workflow_type: [''],
    workflow_status: [''],
    workflow_string_search: [''],
    days_before_expire: [''],
    workflow_with_deadline: [0],
    workflow_with_attachments: [0],
    radio_options: [0],
    workflow_comment: [''],
    checkbox_option: [],
    dropdown_choice: ['q2'],
    workflow_text: [''],
    datetime_answer: [''],
    date_asnwer: [''],
    is_simple_accept: true,
    accept_option: [''],
    radio_image_options: [''],
    workflow_stage_title: [''],
    workflow_stage_description: [''],
    workflow_participants_type: ['single'],
    workflow_for_all_users: [''],
    workflow_specific_users: [''],
    return_to_requester: [''],
    end_workflow_silentely: [''],
    workflow_generate_link_requesters: [''],
    timeStart: [],
    search_user_string: [],
    chat_with_participant: [],
    workflowInitationConversation: [''],
    workflow_title: [''],
    workflow_description: [''],
    workflow_create_type: [0],
    on_date_time_start: [''],
    invitation_message: [''],
    on_date_time_end: [''],
    workflow_accepted_rejected: [''],
    statistics_for_creators: [''],
    statistics_for_supervisors: [''],
    statistics_for_allparticipants: [''],
    statistics_anonymized: [''],
    statistics_not_available: [''],
    participants_inform_push: [''],
    selectedStageStats: ['all'],
    filterbyWorkflowState: ['all'],
    show_desc: [true],
    show_chart: [true],
    is_link: [''],
  });

  /***** ADMIN/SUPER/USER MODE SWITCH */
  imageSrc = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb72uP8MZ7wzWKhwGjQhb11TXHkMG5zo2ouw&";
  isAdmin = true;
  isSuper = false;
  isUser = false;
  selectedCard = 'all';
  onChangeMode(userMode: string) {
    if (userMode === 'admin') {
      this.isAdmin = true;
      this.isSuper = false;
      this.isUser = false;
    } else if (userMode === 'super') {
      this.isSuper = true;
      this.isAdmin = false;
      this.isUser = false;
    } else {
      this.isAdmin = false;
      this.isSuper = false;
      this.isUser = true;
    }
  }

  /**** FILTER OPTIONS FOR WORKFLOW TILES*/
  workflowTileFilter: any[] = [
    { id: 'all', name: this.languageService.getTranslationByKey('WORKFLOWFILTERALLMENU') },
    { id: 'standard', name: this.languageService.getTranslationByKey('WORKFLOWFILTERSTANDARDMENU') },
    { id: 'stagecolab', name: this.languageService.getTranslationByKey('WORKFLOWFILTERSTAGECOLABMENU') },
    { id: 'confidential', name: this.languageService.getTranslationByKey('WORKFLOWFILTERCONFIDENTIALMENU') },
    { id: 'draft', name: this.languageService.getTranslationByKey('WORKFLOWFILTERDRAFTMENU') }
  ];
  /**** END */

  /***** FILTER OPTION FOR USER CARDS */
  workflowSelectedFilter: any[] = [
    { id: 'none', name: this.languageService.getTranslationByKey('WORKFLOWSELECTIONACTIONMENU') },
    { id: 'stats', name: this.languageService.getTranslationByKey('WORKFLOWSHOWSTATSFORSELECTEDMENU') },
    { id: 'delete', name: this.languageService.getTranslationByKey('WORKFLOWDELETESELECTEDMENU') },
  ];

  workflowCompletedFilter: any[] = [
    { id: 'recent', name: this.languageService.getTranslationByKey('WORKFLOWFILTERBYRECENTMENU') },
    { id: 'alphabetical', name: this.languageService.getTranslationByKey('WORKFLOWFILTERALPAHBETICALMENU') },
    { id: 'requester_name', name: this.languageService.getTranslationByKey('WORKFLOWFILTERREQUESTERNAMEMENU') },
    { id: 'publish_date', name: this.languageService.getTranslationByKey('WORKFLOWFILTERCREATEDATMENU') },
    { id: 'unpublish_date', name: this.languageService.getTranslationByKey('WORKFLOWFILTEREXPIREDATEMENU') },
    { id: 'completed', name: this.languageService.getTranslationByKey('WORKFLOWFILTERCOMPLETEDDATEMENU') },
  ];

  workflowEndedFilter: any[] = [
    { id: 'recent', name: this.languageService.getTranslationByKey('WORKFLOWFILTERBYRECENTMENU') },
    { id: 'alphabetical', name: this.languageService.getTranslationByKey('WORKFLOWFILTERALPAHBETICALMENU') },
    { id: 'expired', name: this.languageService.getTranslationByKey('WORKFLOWFILTEREXPIREDMENU') },
    { id: 'cancelled', name: this.languageService.getTranslationByKey('WORKFLOWFILTERCANCELEDMENU') }
  ];

  workflowOngoingFilter: any[] = [
    { id: 'recent', name: this.languageService.getTranslationByKey('WORKFLOWFILTERBYRECENTMENU') },
    { id: 'alphabetical', name: this.languageService.getTranslationByKey('WORKFLOWFILTERALPAHBETICALMENU') },
    { id: 'draft', name: this.languageService.getTranslationByKey('WORKFLOWFILTERDRAFTMENU') },
    { id: 'inprogress', name: this.languageService.getTranslationByKey('WORKFLOWFILTERINPROGRESSMENU') }
  ];
  /**** END  */

  /**** ADMIN/SUPER/USER MAIN MENU CONTENT */

  setSelectedCard(card: string) {
    this.selectedCard = card;
  }

  handleCardKey(event: KeyboardEvent, card: string) {
    console.log(event);
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.setSelectedCard(card);
    }
  }
  /**** END  */

  /**** SIDE PANELS */
  isPanelOpen = false;
  isPanel1Open = false;
  isSearchPanelOpen = false;
  isSearchPanel1Open = false;

  closePanel() {
    this.isPanelOpen = false;
    this.isPanel1Open = false;
    this.isSearchPanelOpen = false;
    this.isSearchPanel1Open = false;
  }

  openPanel() {
    this.isPanelOpen = true;
  }

  openPanel1() {
    this.isPanel1Open = true;
  }

  openSearchPanel() {
    this.isSearchPanelOpen = true;
  }

  openSearch1Panel() {
    this.isSearchPanel1Open = true;
  }

  openAttachment() {
    alert('Open the same window as in news for attachment!')
  }

  public workflowType: any[] = [{ id: 'standard', name: this.languageService.getTranslationByKey('WORKFLOWTYPESTANDARD') }, { id: 'confidential', name: this.languageService.getTranslationByKey('WORKFLOWTYPECONFIDENTIAL') }];
  public workflowReviewResult: any[] = [{ id: 'accepted', name: this.languageService.getTranslationByKey('WORKFLOWSWHICHWEREACCEPTED') }, { id: 'confidential', name: this.languageService.getTranslationByKey('WORKFLOWSWHICHWEREREJECTED') }];
  public participantsUserIDs: number[] = [108];
  public workflowStatus: any[] = [{ id: 'completed', name: this.languageService.getTranslationByKey('WORKFLOWTYPECOMPLETED') }, { id: 'draft', name: this.languageService.getTranslationByKey('WORKFLOWTYPEDRAFT') }, { id: 'ongoing', name: this.languageService.getTranslationByKey('WORKFLOWTYPEONGOING') }, { id: 'canceled', name: this.languageService.getTranslationByKey('WORKFLOWTYPECANCELED') }, { id: 'expired', name: this.languageService.getTranslationByKey('WORKFLOWTYPEEXPIRED') }];
  /**** END */

  /*** DIALOGS  */
  onOpenDialog = (event: any, id: string): void => {
    event.preventDefault();
    if (id == 'show-workflowoverview') {
      this.showWorkflowOverview.show();
    }
    if (id == 'show-workflowoverviewtile') {
      this.showWorkflowOverviewForTile.show();
    }
    if (id == 'show-workflowstageparticipants') {
      this.showAllStageParticipants.show();
    }

    if (id == 'show-workflowsettings') {
      this.createNewWorkflowDialog.show();
    }

    if (id == 'show-workflowstats') {
      this.showWorkflowStats.show();
    }
    if (id == 'show-workflowinstancestats') {
      this.showWorkflowInstanceStats.show();
    }

    if (id == 'show-workflowrequesterslist') {
      this.showRequestersList.show();
    }

  }

  closeDialog(id = ""): void {
    if (id == 'show-workflowoverview') {
      this.showWorkflowOverview.hide();
    }

    if (id == 'show-workflowoverviewtile') {
      this.showWorkflowOverviewForTile.hide();
    }

    if (id == 'show-workflowstageparticipants') {
      this.showAllStageParticipants.hide();
    }

    if (id == 'show-workflowsettings') {
      this.createNewWorkflowDialog.hide();
    }

    if (id == 'show-workflowstats') {
      this.showWorkflowStats.hide();
    }

    if (id == 'show-workflowinstancestats') {
      this.showWorkflowInstanceStats.hide();
    }

    if (id == 'show-workflowrequesterslist') {
      this.showRequestersList.hide();
    }
  }

  /**** FAKE FUNCTION */
  fakeMethod = (): void => {
    console.log("Fake method");
  }

  toggleWorkflowDescription = true;

  togleWorkflowDescription(): void {
    this.toggleWorkflowDescription = !this.toggleWorkflowDescription;
  }

  public onOpenDialogPreventFocus(args: any): void {
    //Preventing the default dialog focus
    args.preventFocus = true;
  }

  isStageExpanded = false;
  toggleExpanded() {
    this.isStageExpanded = !this.isStageExpanded;
  }

  showForm = false;
  toggleForm(): void {
    this.showForm = !this.showForm;
  }
  ticks = { placement: 'After', largeStep: 1, smallStep: 0.5, showSmallTicks: true };
  public attachmentFiles: FileStorageResource[] = [];

  dropdown_datasource: any[] = [
    { id: '1', name: 'Option 1' },
    { id: '2', name: 'Option 2' },
    { id: '3', name: 'Option 3' }
  ];

  public activeStep = 0;
  public participantsGroupIDs: number[] = [8, 6];
  public participantsMails: string[] = [];
  public pushUserIDs: number[] = [];
  pushGroupIDs: number[] = [];
  public steps: string[] = [this.languageService.getTranslationByKey('WORKFLOWTEXTCONTENTMENUTEXT'), this.languageService.getTranslationByKey('WORKFLOWTYPEMENUTEXT'), this.languageService.getTranslationByKey('WORKFLOWSPLASHMENUTEXT'), this.languageService.getTranslationByKey('WORKFLOWATTACHMENTMENUTEXT'), this.languageService.getTranslationByKey('WORKFLOWSUPERVISORSMENUTEXT'), this.languageService.getTranslationByKey('WORKFLOWSCHEDULINGMENUTEXT'), this.languageService.getTranslationByKey('WORKFLOWSTATISTICSPERMISSIONSMENUTEXT'), this.languageService.getTranslationByKey('WORKFLOWSETTINGSMENUTEXT')];

  openWorkflowCreator(): void {
    alert("open workflows-createsd");
  }

  /*** Stats page related */

  workflowStageFilter: any[] = [
    { id: 'all', name: 'All stages' },
    { id: 'requester', name: 'ST.1 - Requester' },
    { id: 'task', name: 'ST.2 - Task' },
    { id: 'teamtask', name: 'ST.3 - Team Task' },
    { id: 'review', name: 'ST.4 - Review' },
  ];

  filterbyWorkflowState: any[] = [
    { id: 'all', name: 'All instances' },
    { id: 'completed', name: 'Only Completed' },
    { id: 'ongoing', name: 'Only Ongoing' },
    { id: 'expired', name: 'Only Expired' },
    { id: 'canceled', name: 'Only Canceled' },
    { id: 'onerequester', name: 'Specific Instance' },
  ];

  /* Circular Progress */
  //Times Used calculation rule
  timesUsed = 40;

  getMaxTimesUsed(value: number): number {
    if (value <= 10) return 10;
    if (value <= 50) return 50;
    if (value <= 100) return 100;
    return Math.ceil(value / 100) * 100;
  }

  minValue = 0;
  maxValue = 600;
  currentValue = 500;

  textWhenTwoValues(args: ITextRenderEventArgs): void {
    args.text = `${this.currentValue}/${this.maxValue}`;
  }

  textWhenNoPercentage(args: ITextRenderEventArgs): void {
    args.text = `${this.timesUsed}`;
  }

  showEvent(module: string | number | TYPE.FieldSettingsModelWithId = '') {
    if (module == 'onerequester') {
      this.showRequestersList!.show();
    }
  }
  openInstanceStats() {
    this.showRequestersList.hide();
    this.showWorkflowInstanceStats.show();
  }

  /*Chart Section */
  chartWidth = "100%";
  chartHeight = "100%";

  legendSettings = {
    visible: false,
    width: '350', height: '100', border: { width: 0, color: 'var(--our-text-color)' },
    position: 'Bottom', alignment: 'Center'
  };

  center = { x: '50%', y: '50%' };


  resizeTimeout: any;

  @HostListener('window:resize')
  onWindowResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.setResponsiveSize();
    }, 200);
  }

  setResponsiveSize() {
    const screenWidth = window.innerWidth;

    if (screenWidth < 400) {
      this.chartHeight = '200px';
    } else if (screenWidth < 600) {
      this.chartHeight = '250px';
    } else {
      this.chartHeight = '350px';
    }
  }

  datalabel = {
    visible: true,
    //name: 'y',
    position: 'Outside',
    template: '<div class="accumulation-chart-label">${point.y}%</div>',

  };

  public centerLabelData: object = [
    { x: 'A1', y: 61.3 },
    { x: 'A2', y: 24.6 },
    { x: 'A3', y: 5.0 },
    { x: 'A4', y: 2.7 },
    { x: 'A5', y: 2.6 },
    { x: 'A6', y: 3.6 }
  ];

  centerLabel = {
    text: 'Q1',
    hoverTextFormat: '${point.x} : ${point.y}%',
    textStyle: {
      fontWeight: 'bold',
      size: 'var(--our-font-size-small)',
      color: 'var(--our-text-color)',
      fontFamily: 'var(--our-font-family)'
    }
  }

  //Get the generated chart colors for each centerLabelData.x
  public segmentColors: Record<string, string> = {};
  onPointRender(args: any): void {
    const label = args.point.x;
    const color = args.fill;
    this.segmentColors[label] = color;

    //console.log(this.segmentColors);
  }

  //grid for dates
  public dateStatsData: any[] = [
    { date: '2024-03-15', count: 12, percentage: '24%' },
    { date: '2024-03-16', count: 9, percentage: '18%' },
    { date: '2024-03-17', count: 8, percentage: '16%' },
    { date: '2024-03-18', count: 6, percentage: '12%' },
    { date: '2024-03-19', count: 5, percentage: '10%' },
    { date: '2024-03-20', count: 4, percentage: '8%' },
    { date: '2024-03-21', count: 3, percentage: '6%' },
    { date: '2024-03-22', count: 2, percentage: '4%' },
    { date: '2024-04-15', count: 12, percentage: '24%' },
    { date: '2024-04-16', count: 9, percentage: '18%' },
    { date: '2024-04-17', count: 8, percentage: '16%' },
    { date: '2024-04-18', count: 6, percentage: '12%' },
    { date: '2024-04-19', count: 5, percentage: '10%' },
    { date: '2024-04-20', count: 4, percentage: '8%' },
    { date: '2024-04-21', count: 3, percentage: '6%' },
    { date: '2024-04-22', count: 2, percentage: '4%' },
    { date: '2024-05-15', count: 12, percentage: '24%' },
    { date: '2024-05-16', count: 9, percentage: '18%' },
    { date: '2024-05-17', count: 8, percentage: '16%' },
    { date: '2024-05-18', count: 6, percentage: '12%' },
    { date: '2024-05-19', count: 5, percentage: '10%' },
    { date: '2024-05-20', count: 4, percentage: '8%' },
    { date: '2024-05-21', count: 3, percentage: '6%' },
    { date: '2024-05-22', count: 2, percentage: '4%' },

  ];

  /* Chart for Dates */
  public primaryXAxis = {
    valueType: 'Category',
    title: 'Date',
    labelIntersectAction: 'Rotate45',
    titleStyle: {
      size: 'var(--our-font-size-default)', color: 'var(--our-title-color)',
      fontFamily: 'var(--our-font-family)', fontWeight: 'bold'
    },
    labelStyle: {
      size: '9px', color: 'var(--our-text-color)',
      fontFamily: 'var(--our-font-family)'
    }
  };

  public primaryYAxis = {
    title: 'Users',
    labelFormat: '{value}',
    titleStyle: {
      size: 'var(--our-font-size-default)', color: 'var(--our-title-color)',
      fontFamily: 'var(--our-font-family)', fontWeight: 'bold'
    },
    labelStyle: {
      size: '9px', color: 'var(--our-text-color)',
      fontFamily: 'var(--our-font-family)'
    }
  };

  labelMarker = {
    dataLabel: {
      visible: true,
      template: '<div class="accumulation-chart-label">${point.y}</div>'
    }
  };

  zoom = {
    enableMouseWheelZooming: true,
    enablePinchZooming: true,
    enableSelectionZooming: true,
    showToolbar: true,
    mode: 'X'
  };

}
